// Author: T4professor

import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
    selector: 'app-button-rendereject',
    template: `
    <button class="font-sans-3xs usa-button usa-button--accent-warm"[disabled]="isAlreadyRejected" (click)="onClick($event)">{{label}}</button>`,
    standalone: false
})

export class ButtonRendererRejectComponent implements ICellRendererAngularComp {
  params;
  label: string;
  isAlreadyRejected:boolean = false;
  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    if(this.params.node.data.documentStatus === 'Rejected') this.isAlreadyRejected = true;
    if(this.params.node.data.documentType.includes('TSP Agreement')) this.isAlreadyRejected = true;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      };
      this.params.onClick(params);
    }
  }
}
